import React from "react";
import { useNavigate } from "react-router-dom";

function ResourcesUpdate() {
  const navigate = useNavigate();

  return (
    <div className="w-full home-goal px-6 md:px-10 py-12">
      {/* Container with matching theme: Dark background, rounded corners, and subtle border */}
      <div className="bg-[#fff]/5 backdrop-blur-md border border-cyan-500/10 rounded-[2.5rem] p-10 md:p-16 flex flex-col items-start gap-6">
        
        {/* Heading: Using your site's font weight and color */}
        <h2 className="text-white text-4xl md:text-4xl font-semibold w-full leading-tight">
          Resources, Video Insights, and Product Updates
        </h2>

        {/* Description: Matching the text-gray-400 from your theme */}
        <p className="text-gray-400 text-lg md:text-xl max-w-2xl leading-relaxed">
          Explore product videos, platform highlights, enterprise insights, and MapleCloud 
          updates across security, operations, and business software.
        </p>

        {/* Button Group */}
        <div className="flex flex-wrap gap-4 mt-4">
          {/* Primary CTA: Matches your "Visit YouTube" style */}
          <button 
            className="bg-cyan-700 hover:bg-cyan-600 text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 shadow-lg shadow-blue-500/20"
            onClick={() => window.open("https://www.youtube.com/@MapleCloudTechnologies", "_blank")}
          >
            Visit YouTube Channel
          </button>

          

          {/* Tertiary CTA */}
          <button 
            className="bg-white/5 hover:bg-white/10 text-white border border-white/10 px-8 py-3 rounded-full font-semibold transition-all duration-300"
            onClick={() => navigate("/productpage")}
          >
            Explore Products
          </button>
        </div>
      </div>
    </div>
  );
}

export default ResourcesUpdate;